/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recover_Email_SentInputs */



/**
* | output |
* | --- |
* | "An email has been sent to your inbox! Please check it to continue the recovery process." |
*
* @param {Auth_Recover_Email_SentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recover_email_sent = /** @type {((inputs?: Auth_Recover_Email_SentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recover_Email_SentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine E-Mail wurde an deinen Posteingang gesendet! Bitte überprüfe sie, um den Wiederherstellungsprozess fortzusetzen.")
	return /** @type {LocalizedString} */ ("An email has been sent to your inbox! Please check it to continue the recovery process.")
});